export function getAsyncRoutes(menuList) {
  const routes = []
  function generateRoutes(menus) {
    menus.forEach(menu => {
      // 跳过无url的父菜单（如“斯诺克黄金联赛”本身）
      if (!menu.url) {
        if (menu.children && menu.children.length > 0) {
          generateRoutes(menu.children)
        }
        return
      }
      const route = {
        // 核心修改：去掉开头的 /，使用相对路径（关键！）
        path: menu.url, // 原代码：`/${menu.url}`（绝对路径，错误）
        // 名称：保持唯一（已拼接id）
        name: `${menu.label}-${menu.id}`,
        // 组件：导入路径 = @/views/ + menu.url（此时url包含文件夹+文件名）
        component: () => import(`@/views/${menu.url}.vue`),
        meta: {
          title: menu.label,
          icon: 'el-icon-menu'
        }
      }
      routes.push(route)
      // 递归处理子菜单（如果有的话）
      if (menu.children && menu.children.length > 0) {
        generateRoutes(menu.children)
      }
    })
  }
  generateRoutes(menuList)
  return routes
}

// utils/index.js
import Layout from '@/components/Layout/index'

/**
 * 过滤与转换后端传来的路由字符串为标准的组件对象
 * @param {Array} routes 后端返回的 getRouters 树形数组
 * @returns {Array} 转换后的标准 Vue-Router 数组
 */
export function filterAsyncRoutes(routes) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }

    if (tmp.component) {
      if (tmp.component === 'Layout') {
        tmp.component = Layout
      } else if (tmp.component === 'ParentView') {
        // 适配三级嵌套菜单，如果没有独立 ParentView 组件，可以直接用内联的 router-view 容器包裹
        tmp.component = { render: h => h('router-view') }
      } else {
        const componentPath = tmp.component
        // 动态导入实际的业务页面组件
        tmp.component = () => import(`@/views/${componentPath}.vue`)
      }
    }

    // 递归处理子路由
    if (tmp.children && tmp.children.length > 0) {
      tmp.children = filterAsyncRoutes(tmp.children)
    }

    res.push(tmp)
  })

  return res
}